(() => {
  const qs = (sel, root = document) => root.querySelector(sel);
  const qsa = (sel, root = document) => Array.from(root.querySelectorAll(sel));

  document.addEventListener('click', (event) => {
    const toggle = event.target.closest('[data-menu-toggle]');
    if (!toggle) return;
    const nav = qs('[data-mobile-nav]');
    const open = nav?.classList.toggle('is-open');
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    const closed = toggle.querySelector('[data-icon-closed]');
    const opened = toggle.querySelector('[data-icon-open]');
    if (closed && opened) {
      closed.hidden = !!open;
      opened.hidden = !open;
    }
  });

  document.addEventListener('click', (event) => {
    const minus = event.target.closest('[data-qty-minus]');
    const plus = event.target.closest('[data-qty-plus]');
    if (!minus && !plus) return;
    const wrap = event.target.closest('[data-qty]');
    const input = wrap?.querySelector('[data-qty-input]');
    if (!input) return;
    const current = parseInt(input.value, 10) || 1;
    const next = minus ? Math.max(0, current - 1) : current + 1;
    input.value = next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  window.House = window.House || {};
  window.House.qs = qs;
  window.House.qsa = qsa;
  window.House.formatMoney = (cents) => {
    if (window.Shopify?.formatMoney) return window.Shopify.formatMoney(cents);
    const value = (Number(cents) / 100).toFixed(2);
    return `$${value}`;
  };
})();
